import styled from "styled-components";
import { Theme } from "../../../common/Theme";

const BackgroundWrapper = styled.div`
    background-color: ${Theme.color.indigo400};
    height: 100vh;
    width: 100vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const ContentContainer = styled.div`
    background-color: #ffffff;
    border-radius: 24px;
    width: 80vw;
    height: auto;
    padding: ${({ $padding }) => $padding || "20px 20px"};
    overflow-y: ${({ overflowY }) => overflowY || "auto"};
    overflow-x: ${({ overflowX }) => overflowX || "hidden"};
    max-height: ${({ maxHeight }) => maxHeight};
`;

const InlineScroll = styled.div`
    overflow-y: ${({ overflowY }) => overflowY || "auto"};
`;

function MobileAuthContentWrapper({
    children,
    contentPadding = "20px 20px",
    header,
    footer,
    overflowY,
    overflowX,
    contentMaxHeight = "90vh",
}) {
    return (
        <BackgroundWrapper>
            <ContentContainer
                $padding={contentPadding}
                overflowY={overflowY}
                overflowX={overflowX}
                maxHeight={contentMaxHeight}
            >
                {header}
                {header || footer ? <InlineScroll>{children}</InlineScroll> : children}
                {footer}
            </ContentContainer>
        </BackgroundWrapper>
    );
}

export default MobileAuthContentWrapper;
